module.exports = __webpack_public_path__ + "static/media/new_pack_super_dog_FR_768x350.1212e1c8.png";